import { CallMethodEnums } from '@/types/api';
import {
  CreateSecretReq,
  CreateSecretRes,
  GetSecretRes,
  GetSecretsRes,
  SecretDetail,
  SecretListItem,
  SecretWithValue,
  UpdateSecretGlobalReq,
  UpdateSecretReq,
  UpdateSecretRes
} from '@/types/secret';

import { callJson, executeFetch } from './utils';

const SECRETS_BASE = '/api/proxy/aidp-core/v3/secrets';

export const secretsGet = async(): Promise<SecretListItem[]> => {
  const res = await callJson<undefined, GetSecretsRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: SECRETS_BASE
  } );
  // aidp-core returns { data: {} } when there are no secrets in the workspace.
  // Returning undefined from a TanStack Query queryFn throws and triggers the
  // retry-storm we see in the network panel — coerce to [] instead.
  return res.data?.secrets ?? [];
};

export const secretGet = async( secretId: string ): Promise<SecretWithValue> => {
  const res = await callJson<undefined, GetSecretRes>( {
    isProtected: true,
    method: CallMethodEnums.GET,
    route: `${ SECRETS_BASE }/${ encodeURIComponent( secretId ) }`
  } );
  return res.data;
};

export const secretCreate = async( body: CreateSecretReq ): Promise<SecretDetail> => {
  const res = await callJson<CreateSecretReq, CreateSecretRes>( {
    body,
    isProtected: true,
    method: CallMethodEnums.POST,
    route: SECRETS_BASE
  } );
  return res.data;
};

export const secretUpdate = async( secretId: string, body: UpdateSecretReq ): Promise<SecretDetail> => {
  const res = await callJson<UpdateSecretReq, UpdateSecretRes>( {
    body,
    isProtected: true,
    method: CallMethodEnums.PATCH,
    route: `${ SECRETS_BASE }/${ encodeURIComponent( secretId ) }`
  } );
  return res.data;
};

export const secretUpdateGlobal = async( secretId: string, body: UpdateSecretGlobalReq ): Promise<SecretDetail> => {
  const res = await callJson<UpdateSecretGlobalReq, UpdateSecretRes>( {
    body,
    isProtected: true,
    method: CallMethodEnums.PATCH,
    route: `${ SECRETS_BASE }/${ encodeURIComponent( secretId ) }/global`
  } );
  return res.data;
};

export const secretDelete = async( secretId: string ): Promise<void> => {
  const res = await executeFetch( {
    isProtected: true,
    method: CallMethodEnums.DELETE,
    route: `${ SECRETS_BASE }/${ encodeURIComponent( secretId ) }`
  } );

  if ( !res.ok ) {
    throw new Error( `Failed to delete secret: ${ res.status }` );
  }
};
